import Markdown from 'markdown-to-jsx'

import { type FAQQuestionType } from '@/legacy-src/components/pageBlocks/types'
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/legacy-src/components/ui/accordion'

type FAQItemProps = {
  item: FAQQuestionType
  isBusinessPage?: boolean
}

const FAQItem: React.FC<FAQItemProps> = ({ item, isBusinessPage }) => {
  if (!item.question || !item.answer) return null

  return (
    <AccordionItem value={item.question} variant="faq">
      <AccordionTrigger isBusinessPage={isBusinessPage} variant="faq">
        <div className="m-0 p-0 text-lg font-bold">{item.question}</div>
      </AccordionTrigger>
      <div className="text-base">
        <AccordionContent variant="faq">
          <Markdown
            options={{
              overrides: {
                a: {
                  props: {
                    className: `underline hover:no-underline ${isBusinessPage ? 'hover:text-pink-500 text-pink-500' : 'hover:text-peach-500 text-peach-500'}`,
                  },
                },
              },
            }}
          >
            {item.answer}
          </Markdown>
        </AccordionContent>
      </div>
    </AccordionItem>
  )
}

type FAQProps = {
  className?: string
  faqs: { entry: FAQQuestionType[] }
  type?: 'single' | 'multiple'
  isBusinessPage?: boolean
}

const FAQ: React.FC<FAQProps> = ({ faqs, type = 'multiple', isBusinessPage, className = '' }) => {
  return (
    <Accordion type={type} className={className}>
      {/* the nested .entry is needed for compatibility with Strapi */}
      {faqs.entry.map((faqItem, key) => {
        return <FAQItem item={faqItem} key={`faq-${key}`} isBusinessPage={isBusinessPage} />
      })}
    </Accordion>
  )
}

export default FAQ
